import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Job } from '../../../jobs-module/models/job.model';
import { Unit } from '../../models/unit';
import {
  JobListingItem,
  LISTING_ITEM_ABOUT_JOB,
  LISTING_ITEM_ABOUT_OFFICE,
  LISTING_ITEM_FOOTER,
  LISTING_ITEM_FREE_TEXT,
  LISTING_ITEM_FREE_TEXT_IMAGE,
  LISTING_ITEM_HEADER,
  LISTING_ITEM_IMAGE,
  LISTING_ITEM_JOBS,
  LISTING_ITEM_TYPE,
  LISTING_ITEM_VIDEO,
} from '../../../jobs-module/models/listing.model';
import { FormBuilder } from '@angular/forms';
import { CareerListing } from '../career-page/career-page.model';

@Component({
  selector: 'mj-career-page-listing',
  templateUrl: './mj-career-page-listing.component.html',
  styleUrls: ['./mj-career-page-listing.component.scss'],
})
export class MjCareerPageListingComponent {
  @Input() job: Job;
  @Input() unit: Unit;
  @Input() listing: CareerListing;
  @Output() onListingChanged = new EventEmitter<any>();

  public rearrangeState = false;

  constructor(private fb: FormBuilder) {}

  addItem(item: JobListingItem) {
    const newItem: any = this._getItemFromType(item.type);
    const newListingItems = [...this.listing.career_page_items];
    newListingItems.splice(item.position, 0, {
      ...newItem,
      free_text_image_type: item.free_text_image_type,
    });
    const newListingItemsWithNewPositions = newListingItems.map((it, index) => {
      return { ...it, position: index };
    });
    this.onListingChanged.emit({
      job: this.job,
      listing: {
        ...this.listing,
        career_page_items: newListingItemsWithNewPositions,
      },
    });
  }

  removeItem(item: JobListingItem) {
    const newListingItems = this.listing.career_page_items
      .filter(listingItem => listingItem.position !== item.position)
      .map((it, index) => {
        return { ...it, position: index };
      });
    this.onListingChanged.emit({
      job: this.job,
      listing: {
        ...this.listing,
        career_page_items: newListingItems,
      },
    });
  }

  updateListing(item: JobListingItem) {
    const newListingItems = [...this.listing.career_page_items];
    newListingItems.splice(item.position, 1, item);
    this.onListingChanged.emit({
      job: this.job,
      listing: {
        ...this.listing,
        career_page_items: newListingItems,
      },
    });
  }

  rearrangeListing(items: JobListingItem[]) {
    this.onListingChanged.emit({
      job: this.job,
      listing: { ...this.listing, job_listing_items: items },
    });
  }

  presentRearrangeScreen(enabled: boolean) {
    this.rearrangeState = enabled;
  }

  trackByFn(index, item) {
    return index;
  }

  _getItemFromType(type: number) {
    switch (type) {
      case LISTING_ITEM_TYPE.LISTING_ITEM_HEADER:
        return LISTING_ITEM_HEADER;
      case LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_JOB:
        return LISTING_ITEM_ABOUT_JOB;
      case LISTING_ITEM_TYPE.LISTING_ITEM_IMAGE:
        return LISTING_ITEM_IMAGE;
      case LISTING_ITEM_TYPE.LISTING_ITEM_VIDEO:
        return LISTING_ITEM_VIDEO;
      case LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT:
        return LISTING_ITEM_FREE_TEXT;
      case LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT_IMAGE:
        return LISTING_ITEM_FREE_TEXT_IMAGE;
      case LISTING_ITEM_TYPE.LISTING_ITEM_FOOTER:
        return LISTING_ITEM_FOOTER;
      case LISTING_ITEM_TYPE.LISTING_ITEM_JOBS:
        return LISTING_ITEM_JOBS;
      case LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_OFFICE:
        return LISTING_ITEM_ABOUT_OFFICE;
      default:
        return LISTING_ITEM_FREE_TEXT_IMAGE;
    }
  }
}
